export const ADD_TO_COMPARE = 'ADD_COMPARE'
export const REMOVE_FROM_COMPARE = 'REMOVE_FROM_COMPARE'
export const RESET_COMPARE = 'RESET_COMPARE'
export const SET_COMPARE_PROPERTY = 'SET_COMPARE_PROPERTY'
export const ADD_RESOURCES_TO_COMPARE = 'ADD_RESOURCES_TO_COMPARE'
